import axios from 'axios';
import $ from 'jquery';
import Api, { handleError } from '@/services/Api';
const API_URL = process.env.API_BASE;

export async function listDesignBoardSettingsApi(params = {}) {
  const url = `${API_URL}/design_board/settings/`;
  try {
    const response = await Api.get(url, {
      params,
      paramsSerializer: (query) => $.param(query),
    });
    return { status: response.status, data: response.data };
  } catch (error) {
    const response = error && error.response ? error.response : null;
    if (response && response.status === 403) {
      return { status: response.status, data: response.data };
    }
    const handled = handleError(error);
    if (!handled) {
      return { status: 0, data: null };
    }
    return { status: handled.status, data: handled.data };
  }
}

export async function createDesignBoardSettingApi(payload) {
  const url = `${API_URL}/design_board/settings/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function updateDesignBoardSettingApi(id, payload) {
  const url = `${API_URL}/design_board/settings/${id}/`;
  const { status, data } = await Api.put(url, payload).catch(handleError);
  return { status, data };
}

export async function deleteDesignBoardSettingApi(id) {
  const url = `${API_URL}/design_board/settings/${id}/`;
  const { status, data } = await Api.delete(url).catch(handleError);
  return { status, data };
}

export async function fetchDesignBoardProjectPdfBlob(projectId, board) {
  const url = `${API_URL}/design_board/project/${projectId}/download/`;
  const { status, data } = await Api.get(url, {
    params: { board },
    responseType: 'blob',
  }).catch(handleError);
  return { status, data };
}

export function buildDesignBoardSharedPdfStreamUrl(token) {
  const encodedToken = encodeURIComponent(token);
  return `${API_URL}/public/design_board/pdf/${encodedToken}/`;
}

function buildDesignBoardSharedPdfMetaUrl(token) {
  const encodedToken = encodeURIComponent(token);
  return `${API_URL}/public/design_board/pdf/${encodedToken}/meta/`;
}

/**
 * Meta (decode token, no S3) for tab title + 404; iframe loads stream URL once (one S3 get_object).
 */
export async function resolveDesignBoardSharedPdfView(token) {
  const trimmed = String(token || '').trim();
  if (!trimmed) {
    return { ok: false, streamUrl: null, filename: '' };
  }
  const streamUrl = buildDesignBoardSharedPdfStreamUrl(trimmed);
  try {
    const response = await axios.get(buildDesignBoardSharedPdfMetaUrl(trimmed), {
      validateStatus: () => true,
    });
    if (response.status !== 200 || !response.data || !response.data.filename) {
      return { ok: false, streamUrl: null, filename: '' };
    }
    return {
      ok: true,
      streamUrl,
      filename: response.data.filename,
      message: '',
    };
  } catch (e) {
    return { ok: false, streamUrl: null, filename: '' };
  }
}
